// extracted by mini-css-extract-plugin
export default {"badgeDay":"badge-day_badgeDay__RKE8a","badgeText":"badge-day_badgeText__Z4T4p"};